// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a7ddd525","455":"71d122d1"}[chunkId] + ".chunk.js";
};